export enum OfferTypesEnum {
  EIP712Domain = 'EIP712Domain',
  TradeItem = 'TradeItem',
  TradeBid = 'TradeBid',
  TradeOffer = 'TradeOffer',
  Trade = 'Trade',
}
